﻿import {
	IntegraHolderData,
	PermitFullEntityResult, RequiredResidencyProperties,
	ResidencyId,
	ResidencyResult
} from "@2d-front-monorepo/permits-business";
import {JSX} from "react";
import {ResidencyComponent} from "./ResidencyComponent";

export function ResidencyWithChangeComponent({holderData, residency, hiddenEntityProperties, changedResidency}: {
	holderData: IntegraHolderData,
	residency: PermitFullEntityResult<ResidencyId, ResidencyResult>,
	hiddenEntityProperties: RequiredResidencyProperties,
	changedResidency: PermitFullEntityResult<ResidencyId, ResidencyResult> | undefined,
}): JSX.Element | undefined {
	if (!changedResidency) {
		return <ResidencyComponent residency={residency} holderData={holderData} hiddenEntityProperties={hiddenEntityProperties} showStatus={false}/>;
	}

	return <div className="columns gap">
		<div className="col50"><ResidencyComponent residency={residency} holderData={holderData} hiddenEntityProperties={hiddenEntityProperties} showStatus={true}/></div>
		<div className="col50"><ResidencyComponent residency={changedResidency} holderData={holderData} hiddenEntityProperties={hiddenEntityProperties} showStatus={true}/></div>
	</div>
}
